<template>
  <div class="backup-labels-container">


    <h3 class="language-title">LANGUAGES</h3>

    <b-button
      variant="primary"
      @click="
        openModal(
          'New Language',
          'Crear',
          null,
          false,
          'Has been created successfully'
        )
      "
    >
      Add new
    </b-button>

    <h4 class="backup-labels-sub-title">EXISTING LANGUAGES</h4>

    <b-table :items="getAllLangs" :fields="fields" striped>
      <template #cell(state)="data">
        <div v-if="data.item.active">Enable</div>
        <div v-if="!data.item.active">Disable</div>
      </template>

      <template #cell(action)="data">
        <b-button
          variant="primary"
          @click="
            openModal(
              'Edit Language',
              'Save',
              data.item,
              false,
              'Has been saved successfully'
            )
          "
        >
          Edit
        </b-button>
        <!--                <b-button style="margin-left: 15px" variant="danger" @click="deleteLang(data.item.id)">
                    Delete
                </b-button>-->
      </template>
    </b-table>

    <div>
      <b-modal
        id="modalInfo"
        v-model="showModal"
        modal-class="modalInfo"
        :title="modalInfo.title"
      >
        <b-container v-if="!success">
          <b-row>
            <b-col>
              <b-form @submit.prevent="">
                <b-form-group label-class="text-xs-center">
                  <template slot="label"> Code language </template>
                  <b-form-input
                    id="id"
                    v-model="model.id"
                    type="text"
                    required
                  />
                </b-form-group>
                <form-error :errors="errors['id']" :field-name="'id'" />

                <b-form-group label-class="text-xs-center">
                  <template slot="label"> Name </template>
                  <b-form-input
                    id="language"
                    v-model="model.language"
                    type="text"
                    required
                  />
                </b-form-group>
                <form-error
                  :errors="errors['language']"
                  :field-name="'language'"
                />

                <b-form-group label-class="text-xs-center">
                  <template slot="label"> Activate </template>
                  <b-form-checkbox
                    v-model="model.active"
                    name="check-button"
                    switch
                  >
                    {{ model.active ? "Enable" : "Disable" }}
                  </b-form-checkbox>
                </b-form-group>

                <div v-if="!model.active">
                  <b-checkbox v-model="confirmation">
                    I confirm that I understand this action will disable this language
                    in the system.
                  </b-checkbox>
                  <form-error
                    :errors="errors['confirmation']"
                    :field-name="'confirmation'"
                  />
                  <div>
                  If you are sure you want to disable the language in the system, please
                  write the word YES in the field below:
                  <b-input v-model="yesInput" />
                    <form-error
                      :errors="errors['yesInput']"
                      :field-name="'yesInput'"
                    />
                  </div>
                </div>
              </b-form>
            </b-col>
          </b-row>
        </b-container>

        <div v-if="success" style="text-align: center">
          {{ successMessage }}
        </div>

        <div
          v-if="success"
          slot="modal-footer"
          class="w-100"
          style="text-align: right"
        >
          <b-btn variant="primary" @click="clearModal()"> OK </b-btn>
        </div>

        <div
          v-if="!success"
          slot="modal-footer"
          class="w-100"
          style="text-align: right"
        >
          <b-btn variant="primary" @click="saveLanguage()">
            {{ modalInfo.actionName }}
          </b-btn>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { axiosCall } from "../../../../utils/axiosCall";
import FormError from "../../../template/_template-error.vue";
import { validateField } from "../../../../utils/commons";
import { mapGetters } from "vuex";

export default {
  name: "Languages",
  components: {
    FormError,
  },
  data: function () {
    return {

      fields: ["id", "language", "state", "action"],
      showModal: false,
      modalInfo: { title: "", actionName: "" },
      success: false,
      model: { id: "", language: "", active: true },
      errors: {},
      confirmation: false,
      yesInput: '',
      validations: {
        id: ["required"],
        language: ["required"],
      },
      id: null,
      successMessage: "",
    };
  },
  methods: {
    validateForm() {
      this.errors = { ...{} };
      var keys = Object.keys(this.model);
      for (var i = 0; i < keys.length; i++) {
        validateField(
          keys[i],
          this.model[keys[i]],
          this.validations[keys[i]],
          this.errors
        );
      }

      if(!this.model.active){
        if(!this.confirmation){
          this.errors['confirmation']=['required']
        }
        if(this.yesInput !== 'YES'){
          this.errors['yesInput']=['required']
        }
      }

      var errors = Object.keys(this.errors)
        .filter((s) => this.errors[s])
        .filter((r) => this.errors[r].length > 0);
      return errors.length === 0;
    },
    openModal: async function (
      title,
      actionName,
      lang,
      success = false,
      message = ""
    ) {
      this.clearModal(success);
      if (lang) {
        this.id = lang.id;
        this.model = {
          id: lang.id,
          language: lang.language,
          active: lang.active,
        };
          this.confirmation = false
          this.yesInput= ''
      }
      this.successMessage = message;
      this.showModal = true;
      this.modalInfo.title = title;
      this.modalInfo.actionName = actionName;
    },
    clearModal(success = false) {
      this.errors = { ...{} };
      this.id = null;
      this.showModal = false;
      this.model = { id: "", language: "", active: true };
      this.success = success;
    },
    getAvailableLangs: function () {
      this.$store.dispatch("availableLanguages");
    },
    saveLanguage: async function () {
      if (this.validateForm()) {
        const data = this.model;

        if (this.id) {
          axiosCall({
            url: `Langs/update?where=${JSON.stringify({ id: this.id })}`,
            method: "POST",
            data,
          })
            .then(() => {
              this.success = true;
              this.getAvailableLangs();
              this.$store.dispatch("availableLanguages");
            })
            .catch(() => {
            });
        } else {
          const ids = this.getAllLangs.map((lang) => lang.id);
          if (!ids.includes(data.id)) {
            axiosCall({ url: "Langs", method: "POST", data })
              .then(() => {
                this.success = true;
                this.getAvailableLangs();
                this.$store.dispatch("availableLanguages");
              })
              .catch(() => {
              });
          } else {
            this.errors["id"].push("repeated");
          }
        }
      }
    },
    deleteLang: async function (id) {
      const ids = this.getAllLangs.map((lang) => lang.id);
      if (ids.includes(id)) {
        axiosCall({ url: `Langs/${id}`, method: "delete" })
          .then(() => {
            this.getAvailableLangs();
            this.$store.dispatch("availableLanguages");
            this.successMessage = "Has been successfully removed";
            this.openModal(
              "Successfully removed",
              "",
              null,
              true,
              "Has been successfully removed"
            );
          })
          .catch(() => {
          });
      }
    },
  },
  computed: {
    ...mapGetters(["getAllLangs"]),
  },
};
</script>
<style lang="scss">
.language {
  &-title {
    margin-bottom: 15px;
  }
}
</style>
